import React from "react";
import { FormLayoutStyled, MainLayoutStyled } from "./style";
import Header from "../../components/Header/index";
import Footer from "../../components/Footer/index";
var MainLayout = function (_a) {
    var children = _a.children;
    return (React.createElement(MainLayoutStyled, null,
        React.createElement(Header, null),
        React.createElement(FormLayoutStyled, null, children),
        React.createElement(Footer, null)));
};
export default MainLayout;
